import axios from 'axios'

import { axiosInterceptorAdministrator } from './interceptors/administrator.interceptor.js'
import { axiosInterceptorErrorTransformation } from './interceptors/error-transformation.interceptor.js'
import { axiosInterceptorRefreshToken } from './interceptors/refresh-token.interceptor.js'

export const serviceEndpoints = {
  'core': 'core/v1',
  'dashboard-insights': 'dash-insights/v1',
  'action-tracker': 'action-tracker/v1',
  'gatekeeper': 'gatekeeper/v1',
  'safety-observation': 'safety-observation/v1',
  'target-scheduling': 'targeting-scheduling/v1',
  'risk-profiling': 'risk-profiling/v1',
  'new-risk-profiling': 'new-risk-profiling/v1',
  'bpo': 'bpo/v1',
  'incident-management': 'incident-management/v1',
  'authorization': 'authorization/v1',
  'spi': 'spi/v1',
  'unsafe-condition': 'unsafe-condition/v1',
  'pdf-service': 'pdf-service/v1',
  'work-cycle-verification': 'work-cycle-verification/v1',
  'action-tracker-v2': 'new-action-tracker/v1/',
  'consultant-visit': 'consultant-visit/v1/',
  'leadership-assessment': 'leadership-assessment/v1',
  'leadership-assessment-v2': 'leadership-assessment/v2',
  'coaching-tracker': 'coaching-tracker/v1',
  'surveyjs': 'surveyjs/v1',
  'incident-observation-analytics': 'incident-observation-analytics/v1',
  'sps': 'sps/v1',
  'generic-survey': 'surveyjs/v1',
  'massive-import': 'mass-import/v1',
}

const serviceConfigs = {
  'pdf-service': {
    headers: {
      Authorization: `Basic ${import.meta.env.VITE_PDF_SERVICE_AUTH_KEY}`,
    },
    defaultConfig: {
      responseType: 'blob',
    },
  },
}

function getServiceConfig(service) {
  const baseHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }

  const serviceConfig = serviceConfigs[service] || {}
  const serviceHeaders = serviceConfig?.headers || {}
  const defaultConfig = serviceConfig?.defaultConfig || {}

  return {
    headers: {
      ...baseHeaders,
      ...serviceHeaders,
    },
    defaultConfig,
  }
}

const DEFAULT_BASE_URL = 'https://dev-bradley.dss360.app/api'

export class HttpService {
  constructor(service) {
    const baseUrl = import.meta.env.VITE_API_URL || DEFAULT_BASE_URL
    const { headers, defaultConfig } = getServiceConfig(service)

    this.client = axios.create({
      baseURL: `${baseUrl}${serviceEndpoints[service]}`,
      headers,
      withCredentials: true,
      ...defaultConfig,
    })

    this.setupInterceptors()
  }

  setupInterceptors() {
    axiosInterceptorAdministrator(this.client)
    axiosInterceptorRefreshToken(this.client)
    axiosInterceptorErrorTransformation(this.client)
  }

  async get(url, config = {}) {
    return this.client.get(url, config)
  }

  async post(url, data = {}, config = {}) {
    return this.client.post(url, data, config)
  }

  async put(url, data = {}, config = {}) {
    return this.client.put(url, data, config)
  }

  async patch(url, data = {}, config = {}) {
    return this.client.patch(url, data, config)
  }

  async delete(url, config = {}) {
    return this.client.delete(url, config)
  }
}

export const apiClient = service => new HttpService(service)
